import React from "react";
import PropTypes from "prop-types";
import { AuthContextProvider } from "shared/context/auth";
import { ThemeContextProvider } from "shared/context/theme";
import GlobalHeader from "../components/GlobalHeader";

const GlobalHeaderContainer = ({ auth, theme, ...rest }) => (
  <AuthContextProvider auth={auth}>
    <ThemeContextProvider theme={theme}>
      <GlobalHeader {...rest} />
    </ThemeContextProvider>
  </AuthContextProvider>
);

GlobalHeaderContainer.propTypes = {
  auth: PropTypes.shape({}),
  theme: PropTypes.string,
};

GlobalHeaderContainer.defaultProps = {
  auth: {},
  theme: "white",
};

export default GlobalHeaderContainer;
